import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        training: '<',
        trainingTimesWithParticipants: '<',
        participants: '<',
        uibModalInstance: '<'
    },
    template: `
<div class="modal-header">
    <div class="heading01 heading01b">
        <h2>{{ 'occurrence.Test results' | translate }}</h2>
        <ul class="actions01">
            <li><a class="btn bordered02" ng-click="vm.cancel()">{{ 'general.Close' | translate }}</a></li>
        </ul>
    </div>
</div>
<div class="modal-body">
    <div class="search02 w100p">
        <input type="text" ng-model="vm.searchText" placeholder="{{ 'occurrence.Search by name' | translate }}">
    </div>
    <div class="alert alert-plain" ng-if="!vm.filteredParticipants.length">
        <h3>{{ 'general.This table has no content yet' | translate }}</h3>
        <p>{{ 'general.Please add some content' | translate }}</p>
    </div>
    <table class="data01" ng-if="vm.filteredParticipants.length">
        <thead>
        <tr>
            <th ng-class="vm.getSortClass('displayName')">
                <a ng-click="vm.sortBy('displayName')">{{ 'occurrence.User' | translate }}</a>
            </th>
            <th ng-class="vm.getSortClass('progressPc')">
                <a ng-click="vm.sortBy('progressPc')">{{ 'occurrence.Results' | translate }}</a>
            </th>
            <th ng-class="vm.getSortClass('trainingProgressStatus')">
                <a ng-click="vm.sortBy('trainingProgressStatus')">{{ 'occurrence.Status' | translate }}</a>
            </th>
        </tr>
        </thead>
        <tbody>
        <tr ng-repeat="participant in vm.filteredParticipants | orderBy:vm.sortColumn:vm.sortReverse">
            <td>{{ participant.displayName }}</td>
            <td>
                <div ng-if="participant.progressPc != null">{{ participant.progressPc }}%</div>
                <div ng-if="participant.chaptersTotal">{{ participant.chaptersPassed }}/{{ participant.chaptersTotal }}</div>
                <div ng-if="participant.testsTotal">{{ participant.testsPassed }}/{{ participant.testsTotal }}</div>
            </td>
            <td>{{ vm.COURSE_TRAINING_STATUS_TYPE_ENUM.LABELS[participant.trainingProgressStatus] }}</td>
        </tr>
        </tbody>
    </table>
</div>
    `
})
export default class {
    constructor ($scope, lodash, COURSE_TRAINING_STATUS_TYPE_ENUM, $timeout, $element) {
        this.$scope = $scope;
        this.lodash = lodash;
        this.COURSE_TRAINING_STATUS_TYPE_ENUM = COURSE_TRAINING_STATUS_TYPE_ENUM;
        this.$timeout = $timeout;
        this.$element = $element;

        this.searchText = '';
        this.sortColumn = 'displayName';
        this.sortReverse = false;
    }

    $onInit () {
        // Get the training time (should be only one for this special case)
        const trainingTime = this.training.times && this.training.times[0];

        if (trainingTime) {
            // Find the training time with participants
            const tempTrainingTime = this.lodash.find(this.trainingTimesWithParticipants, { id: parseInt(trainingTime.id, 10) });
            this.trainingTimeParticipants = tempTrainingTime ? tempTrainingTime.courseOccurrenceTrainingTimeParticipants : [];

            // Map participants with user data
            this.allParticipants = this.trainingTimeParticipants.map(participant => {
                const user = this.lodash.find(this.participants, { userId: participant.userId });
                if (user) {
                    participant.lastName = user.lastName;
                    participant.firstName = user.firstName;
                    participant.displayName = user.displayName || `${user.firstName} ${user.lastName}`;
                    return participant;
                }
                return null;
            }).filter(p => p !== null);

            this.allParticipants = this.lodash.orderBy(this.allParticipants, ['displayName']);
        }
        else {
            this.allParticipants = [];
        }

        this.filteredParticipants = this.allParticipants;

        // Watch for search text changes
        this.$scope.$watch(() => this.searchText, (newVal) => {
            this.filterParticipants(newVal);
        });

        this.setupClosingAnimation();
    }

    setupClosingAnimation () {
        let closing = false;
        this.$scope.$on('modal.closing', (event, resultOrReason, closed) => {
            if (closing) return;

            const modalDialog = this.$element[0].closest('.modal-dialog');
            if (modalDialog) {
                event.preventDefault();
                closing = true;
                modalDialog.classList.add('slide-out');

                this.$timeout(() => {
                    if (closed) {
                        this.uibModalInstance.close(resultOrReason);
                    }
                    else {
                        this.uibModalInstance.dismiss(resultOrReason);
                    }
                }, 400);
            }
        });
    }

    filterParticipants (searchText) {
        if (!searchText) {
            this.filteredParticipants = this.allParticipants;
        }
        else {
            const lowerSearch = searchText.toLowerCase();
            this.filteredParticipants = this.allParticipants.filter(participant => {
                const fullName = participant.displayName.toLowerCase();
                return fullName.includes(lowerSearch);
            });
        }
    }

    getSortClass (column) {
        if (this.sortColumn === column) {
            return this.sortReverse ? 'sorting_desc' : 'sorting_asc';
        }
        return 'sorting';
    }

    sortBy (column) {
        if (this.sortColumn === column) {
            this.sortReverse = !this.sortReverse;
        }
        else {
            this.sortColumn = column;
            this.sortReverse = false;
        }
    }

    cancel () {
        this.uibModalInstance.dismiss();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/edit/occurrence/steps/schedule/testResults/index.js